import { render, staticRenderFns } from "./PublicRGConnection.vue?vue&type=template&id=49b8665a&scoped=true&"
import script from "./PublicRGConnection.vue?vue&type=script&lang=ts&"
export * from "./PublicRGConnection.vue?vue&type=script&lang=ts&"
import style0 from "./PublicRGConnection.vue?vue&type=style&index=0&id=49b8665a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b8665a",
  null
  
)

export default component.exports